import _ from "lodash";

export type Status = "active" | "paused" | "canceled" | "dunning" | "failed" | "wrapping_up";

export const statuses: Status[] = ["active", "paused", "canceled", "dunning", "failed", "wrapping_up"];

export const selectStatuses = statuses.map((status) => {
  return { value: status, label: status.replaceAll("_", " ").toUpperCase() };
});

export const colorsByStatus: Record<Status, string> = {
  active: "green",
  canceled: "yellow",
  paused: "orange",
  dunning: "red",
  failed: "dark",
  wrapping_up: "violet",
};
